import $http from '@/utils/fetch'

const getPageInfo = data => {
  return $http.post('page/info', data)
}

const getGenerateUrl = data => {
  return $http.post('util/generate/page/url', data)
}

const getAll = data => {
  return $http.post('index', data)
}

export default {
  getPageInfo,
  getGenerateUrl,
  getAll
}
